<template>
  <div>
    <div class="fixed-bottom bg-secondary text-white" v-if="canEditLots || canEditAuctions">
      <div class="container py-2">
        <div class="row" v-if="!loading">
          <div class="col-2 col-md-4">
            <img style="max-width:25px; filter:invert(1);" class="mr-2" src="/assets/img/nova.png"/>
            <span class="d-none d-md-inline">A10 Admin Bar</span>
          </div>
          <div class="col-10 col-md-8">
            <ul class="list-unstyled">
              <li class="float-left mr-3" v-if="canEditLots">
                <a class="font-weight-bold text-white nounderline" target="_blank"
                   :href="'/nova/resources/lots/'+details.id+'/edit'">Edit Lot</a>
              </li>
              <li class="float-left mr-3" v-if="canEditAuctions">
                <a class="font-weight-bold text-white nounderline" target="_blank"
                   :href="'/nova/resources/auctions/'+details.auction_id+'/edit'">Edit Auction</a>
              </li>
              <li class="float-left mr-3" v-if="canEditLots">
                <a class="font-weight-bold text-white nounderline" target="_blank"
                   :href="'/nova/resources/lots/'+details.id">Lot Details</a>
              </li>
              <li class="float-left mr-3" v-if="canEditAuctions">
                <a class="font-weight-bold text-white nounderline" target="_blank"
                   :href="'/nova/resources/auctions/'+details.auction_id">Auction Details</a>
              </li>
              <li class="float-left mr-3" v-if="canEditLots && confirm_sync===false && !syncing">
                                <span @click="confirm_sync=true"
                                      class="font-weight-bold text-white nounderline cursor-pointer">Sync Lot</span>
              </li>
              <li class="float-left mr-3" v-if="canEditLots && confirm_sync===true && !syncing">
                <span @click="erpSync"
                      class="font-weight-bold text-warning nounderline cursor-pointer">Confirm Lot Sync</span>
              </li>
              <li class="float-left mr-3 pr-3" style="background-color:#444; border-radius:10px;"
                  v-if="syncing">
                <svg version="1.1" id="da-loader" xmlns="http://www.w3.org/2000/svg" fill="#fff"
                     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px"
                     height="20px"
                     viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                                    <path fill="#fff"
                                          d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path></svg>
                <span class="font-weight-bold text-white">Syncing</span>
              </li>

            </ul>

          </div>
        </div>
        <div class="loader center-vertically" v-if="loading">
          <svg version="1.1" id="da-loader" xmlns="http://www.w3.org/2000/svg" fill="#fff"
               xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px"
               viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
        <path fill="#fff"
              d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path>
      </svg>
        </div>
      </div>
    </div>
    <div class="iziToast-top-container d-flex justify-content-end">
      <div class="iziToast-top-container-placeholder px-3 pt-3">
      </div>
    </div>
    <div class="loader center-vertically my-5" v-if="loading">
      <svg version="1.1" id="da-loader" xmlns="http://www.w3.org/2000/svg" fill="#3c3c3c"
           xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px"
           viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
        <path fill="#000"
              d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path>
      </svg>
    </div>

    <div v-if="!loading" class="container-fluid">
      <div
          id="stickyOnScroll"
          class="row auction-summary p-0 mb-5 border-bottom center-vertically"
          data-toggle="sticky-onscroll"
          style="background-color: #fff;"
      >
        <div class="col-xl-5 col-lg-7 d-flex py-1">
          <div class="d-flex justify-content-center justify-content-lg-start font-weight-bold w-100">
            <router-link class="nounderline"
                         :to="{name: 'auction', params: {auction: auction.slug} }"
            >{{ makeAuctionShortName() }}
            </router-link>
          </div>
        </div>
        <div class="col-lg-12 d-lg-none p-0">
          <hr class=" m-0"/>
        </div>
        <div class="col-lg-3 offset-lg-2 d-flex justify-content-between text-lg-right py-1 px-0 center-vertically">
          <router-link class="d-flex justify-content-center" v-if="prev" :to="{name: 'lot', params: prev }">
            <svg width="45" height="45" fill="#3c3c3c" viewBox="0 0 20 20"
                 xmlns="http://www.w3.org/2000/svg">
              <polyline fill="none" stroke="#000" stroke-width=".5" points="13 16 7 10 13 4"/>
            </svg>
          </router-link>
          <span v-else> <svg fill="#3c3c3c" width="45" height="45" viewBox="0 0 20 20"
                             xmlns="http://www.w3.org/2000/svg"
          >
              <polyline fill="none" stroke="#fff" stroke-width=".5" points="13 16 7 10 13 4"/>
            </svg>
          </span>
          <div class="css-tooltip bottom">
            <input type="number" class="text-center p-0 number-arrowless w-100"
                   :placeholder="'Lot ' + details.number" v-on:keyup.enter="goToLotInput"/>
            <span class="tt-content text-center border">{{ __('lot-jump-tip') }}<i></i></span>
          </div>
          <router-link class="d-flex justify-content-center" v-if="next" :to="{name: 'lot', params: next }">
            <svg width="45" height="45" fill="#3c3c3c" viewBox="0 0 20 20"
                 xmlns="http://www.w3.org/2000/svg">
              <polyline fill="none" stroke="#000" stroke-width=".5" points="7 4 13 10 7 16"/>
            </svg>
          </router-link>
          <span v-else><svg width="45" height="45" fill="#3c3c3c" viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
          >
              <polyline fill="none" stroke="#fff" stroke-width=".5" points="7 4 13 10 7 16"/>
            </svg>
          </span>
        </div>
      </div>
      <div class="row justify-content-md-center mb-5">
        <div class="col-sm-12 col-lg-5 text-center lot-image-container pt-3" data-spy="affix">
          <div v-if="auction.order == 411 && details.number == 157" class="main-image text-center">
            <video style="max-width: 100%" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/157.mp4" type="video/mp4">
            </video>

          </div>
          <div v-else-if="auction.order == 411 && details.number == 158" class="main-image text-center">
            <video style="max-width: 100%" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/158.mp4" type="video/mp4">
            </video>

          </div>
          <div v-else-if="auction.order == 411 && details.number == 159" class="main-image text-center">
            <video style="max-width: 100%" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/159.mp4" type="video/mp4">
            </video>

          </div>
          <div v-else-if="auction.order == 411 && details.number == 160" class="main-image text-center">
            <video style="max-width: 100%" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/160.mp4" type="video/mp4">
            </video>

          </div>
          <div v-else-if="auction.order == 438 && details.number == 61" class="main-image text-center">
            <video style="max-width: 100%" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/438-61.mp4" type="video/mp4">
            </video>

          </div>
          <div v-else-if="auction.order == 438 && details.number == 62" class="main-image text-center">
            <video style="max-width: 100%" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/438-62.mp4" type="video/mp4">
            </video>

          </div>
          <div v-else-if="auction.order == 442 && details.number == 2" class="main-image text-center">
            <video style="max-width: 100%" controls loop autoplay="autoplay" muted>
              <source src="https://www.artmark.ro/assets/img/lots-video/442-2.mp4" type="video/mp4">
            </video>

          </div>
          <div v-else-if="auction.order == 442 && details.number == 3" class="main-image text-center">
            <video style="max-width: 100%" controls loop autoplay="autoplay" muted>
              <source src="https://www.artmark.ro/assets/img/lots-video/442-3.mp4" type="video/mp4">
            </video>

          </div>
          <div v-else-if="auction.order == 442 && details.number == 4" class="main-image text-center">
            <video style="max-width: 100%" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/442-4.mp4" type="video/mp4">
            </video>

          </div>
          <div v-else-if="auction.order == 442 && details.number == 6" class="main-image text-center">
            <video style="max-width: 100%" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/442-6.mp4" type="video/mp4">
            </video>

          </div>
          <div v-else-if="auction.order == 451 && details.number == 139" class="main-image text-center">
            <video style="max-width: 100%" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/451-139.mp4" type="video/mp4">
            </video>

          </div>
          <div v-else-if="auction.order == 451 && details.number == 143" class="main-image text-center">
            <video style="max-width: 100%" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/451-143.mp4" type="video/mp4">
            </video>

          </div>
          <div v-else-if="auction.order == 462 && details.number == 116" class="main-image text-center">
            <video style="max-width: 100%" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/462-116.mp4" type="video/mp4">
            </video>

          </div>
          <div v-else class="main-image text-center">
            <figure class="lot-image img-fluid" itemprop="associatedMedia" itemscope
                    @click.prevent="loadFullImages"
                    itemtype="http://schema.org/ImageObject">
              <a :href="img" class="thumbnail" itemprop="contentUrl" data-size="1400x1403" ref="main-href"
                 data-pswp-uid="lot-gallery-images" :aria-label="__('lotimage')">
                <img
                    class="lot-image img-fluid"
                    :src="img"
                    itemprop="thumbnail"
                    :alt="details.title"
                />
              </a>

            </figure>
          </div>
          <br/>
          <div class="more-images text-center">
            <div v-if="img_more && img_more.length > 3"
                 class="additional-images-lunchbox container mt-3 mb-5">
              <div class="swiper-container swiper-additional-images">
                <div class="swiper-wrapper">
                  <div v-for="(item,key) in img_more" class="swiper-slide lot-additional-image"
                       style="height:100% !important">
                    <figure class="lot-image img-fluid" itemprop="associatedMedia" itemscope
                            @click.prevent="loadFullImages"
                            itemtype="http://schema.org/ImageObject">
                      <a :href="item" class="thumbnail" itemprop="contentUrl"
                         data-size="1400x1403"
                         :ref="'additional-href-'+key"
                         data-pswp-uid="lot-gallery-images" :aria-label="__('lotimage')"
                         :data-type="getDataType(item)" :data-video="getVideo(item)"
                         style="position:relative; display:inline-block;">
                        <img class="lot-image img-fluid" :src="item"
                             :id="'additional-image-'+key"
                             :ref="'additional-image-'+key"
                             itemprop="thumbnail"
                             alt
                        />
                        <span
                            v-if="youtubeIdFromThumbnail(item)"
                            aria-hidden="true"
                            style="position:absolute; top:50%; left:50%; transform:translate(-50%, -50%); width:56px; height:40px; border-radius:10px; background:rgba(255, 0, 0, .9); color:#fff; font-size:22px; line-height:40px; text-align:center; pointer-events:none; box-shadow:0 2px 8px rgba(0, 0, 0, .35);"
                        >▶</span>
                      </a>
                      <figcaption
                          itemprop="caption description"
                          style="display:none;"
                      >{{ img_more_labels[key] }}
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>

              <!-- Mobile Pagination -->
              <div class="d-flex d-lg-none justify-content-end">
                <div class="swiper-pagination-additional-images mt-2"></div>
              </div>

              <div class="swiper-button-prev prev-additional-images d-none d-lg-block"></div>
              <div class="swiper-button-next next-additional-images d-none d-lg-block"></div>
            </div>

            <ul v-else-if="this.img_more" class="list-inline">
              <li v-for="(item,key) in img_more" class="lot-additional-image">
                <figure class="lot-image img-fluid" itemprop="associatedMedia" itemscope
                        @click.prevent="loadFullImages"
                        itemtype="http://schema.org/ImageObject">
                  <a :href="item" class="thumbnail" itemprop="contentUrl" data-size="1400x1403"
                     :ref="'additional-href-'+key"
                     data-pswp-uid="lot-gallery-images" :aria-label="__('lotimage')"
                     :data-type="getDataType(item)" :data-video="getVideo(item)"
                     style="position:relative; display:inline-block;">
                    <img class="lot-image img-fluid" :src="item" :id="'additional-image-'+key"
                         :ref="'additional-image-'+key"
                         itemprop="thumbnail"
                         alt
                    />
                    <span
                        v-if="youtubeIdFromThumbnail(item)"
                        aria-hidden="true"
                        style="position:absolute; top:50%; left:50%; transform:translate(-50%, -50%); width:56px; height:40px; border-radius:10px; background:rgba(255, 0, 0, .9); color:#fff; font-size:22px; line-height:40px; text-align:center; pointer-events:none; box-shadow:0 2px 8px rgba(0, 0, 0, .35);"
                    >▶</span>
                  </a>
                  <figcaption
                      itemprop="caption description"
                      style="display:none;"
                  >{{ img_more_labels[key] }}
                  </figcaption>
                </figure>
              </li>
              <!--                            <li v-for="(item,key) in video" class="lot-additional-image">-->
              <!--                                <span>yo</span>-->
              <!--                                <figure class="lot-image img-fluid" itemprop="associatedMedia" itemscope-->
              <!--                                        @click.prevent="loadFullImages"-->
              <!--                                        itemtype="http://schema.org/ImageObject">-->
              <!--                                    <a :href="item" class="thumbnail" itemprop="contentUrl" data-size="1400x1403"-->
              <!--                                       :ref="'additional-href-'+key"-->
              <!--                                       data-pswp-uid="lot-gallery-images" :aria-label="__('lotimage')">-->
              <!--                                        <img class="lot-image img-fluid" :src="item" :id="'additional-image-'+key"-->
              <!--                                             :ref="'additional-image-'+key"-->
              <!--                                             itemprop="thumbnail"-->
              <!--                                             alt-->
              <!--                                        />-->
              <!--                                    </a>-->
              <!--                                    <figcaption-->
              <!--                                            itemprop="caption description"-->
              <!--                                            style="display:none;"-->
              <!--                                    >{{img_more_labels[key]}}-->
              <!--                                    </figcaption>-->
              <!--                                </figure>-->
              <!--                            </li>-->
            </ul>
          </div>
          <div class="text-center">
            <button v-if="isFavorite" id="btn-favorite" @click="removeFromFavorites" data-toggle="modal"
                    v-bind:data-original-title="titleUnfav"
                    data-target="#favoritesModal"
                    type="button" class="btn btn-fav btn-fav-details" data-placement="left">
              <svg enable-background="new 0 0 512 512" height="30" viewBox="0 0 512 512"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="m471.382812 44.578125c-26.503906-28.746094-62.871093-44.578125-102.410156-44.578125-29.554687 0-56.621094 9.34375-80.449218 27.769531-12.023438 9.300781-22.917969 20.679688-32.523438 33.960938-9.601562-13.277344-20.5-24.660157-32.527344-33.960938-23.824218-18.425781-50.890625-27.769531-80.445312-27.769531-39.539063 0-75.910156 15.832031-102.414063 44.578125-26.1875 28.410156-40.613281 67.222656-40.613281 109.292969 0 43.300781 16.136719 82.9375 50.78125 124.742187 30.992188 37.394531 75.535156 75.355469 127.117188 119.3125 17.613281 15.011719 37.578124 32.027344 58.308593 50.152344 5.476563 4.796875 12.503907 7.4375 19.792969 7.4375 7.285156 0 14.316406-2.640625 19.785156-7.429687 20.730469-18.128907 40.707032-35.152344 58.328125-50.171876 51.574219-43.949218 96.117188-81.90625 127.109375-119.304687 34.644532-41.800781 50.777344-81.4375 50.777344-124.742187 0-42.066407-14.425781-80.878907-40.617188-109.289063zm0 0"/>
              </svg>
            </button>
            <button v-if="!isFavorite" id="btn-unfavorite" @click="addToFavorites" type="button"
                    class="btn btn-fav btn-fav-details" v-bind:data-original-title="titleFav">
              <svg enable-background="new 0 0 512 512" height="30" viewBox="0 0 512 512"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="m256 455.515625c-7.289062 0-14.316406-2.640625-19.792969-7.4375-20.683593-18.085937-40.625-35.082031-58.21875-50.074219l-.089843-.078125c-51.582032-43.957031-96.125-81.917969-127.117188-119.3125-34.644531-41.804687-50.78125-81.441406-50.78125-124.742187 0-42.070313 14.425781-80.882813 40.617188-109.292969 26.503906-28.746094 62.871093-44.578125 102.414062-44.578125 29.554688 0 56.621094 9.34375 80.445312 27.769531 12.023438 9.300781 22.921876 20.683594 32.523438 33.960938 9.605469-13.277344 20.5-24.660157 32.527344-33.960938 23.824218-18.425781 50.890625-27.769531 80.445312-27.769531 39.539063 0 75.910156 15.832031 102.414063 44.578125 26.191406 28.410156 40.613281 67.222656 40.613281 109.292969 0 43.300781-16.132812 82.9375-50.777344 124.738281-30.992187 37.398437-75.53125 75.355469-127.105468 119.308594-17.625 15.015625-37.597657 32.039062-58.328126 50.167969-5.472656 4.789062-12.503906 7.429687-19.789062 7.429687zm-112.96875-425.523437c-31.066406 0-59.605469 12.398437-80.367188 34.914062-21.070312 22.855469-32.675781 54.449219-32.675781 88.964844 0 36.417968 13.535157 68.988281 43.882813 105.605468 29.332031 35.394532 72.960937 72.574219 123.476562 115.625l.09375.078126c17.660156 15.050781 37.679688 32.113281 58.515625 50.332031 20.960938-18.253907 41.011719-35.34375 58.707031-50.417969 50.511719-43.050781 94.136719-80.222656 123.46875-115.617188 30.34375-36.617187 43.878907-69.1875 43.878907-105.605468 0-34.515625-11.605469-66.109375-32.675781-88.964844-20.757813-22.515625-49.300782-34.914062-80.363282-34.914062-22.757812 0-43.652344 7.234374-62.101562 21.5-16.441406 12.71875-27.894532 28.796874-34.609375 40.046874-3.453125 5.785157-9.53125 9.238282-16.261719 9.238282s-12.808594-3.453125-16.261719-9.238282c-6.710937-11.25-18.164062-27.328124-34.609375-40.046874-18.449218-14.265626-39.34375-21.5-62.097656-21.5zm0 0"/>
              </svg>
            </button>
            <button @click="openShareModal" type="button" class="btn h2 showShareModal" data-toggle="modal"
                    data-target="#shareModal"
                    title="Share"
                    data-placement="left">
              <svg id="Capa_1" enable-background="new 0 0 512 512" height="20" viewBox="0 0 512 512"
                   width="20" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                      d="m407 302c-35.66 0-67.219 17.873-86.205 45.127l-116.132-58.066c3.458-10.4 5.337-21.515 5.337-33.061s-1.879-22.661-5.337-33.061l116.132-58.066c18.986 27.254 50.545 45.127 86.205 45.127 57.897 0 105-47.103 105-105s-47.103-105-105-105-105 47.103-105 105c0 11.546 1.879 22.661 5.337 33.061l-116.132 58.066c-18.986-27.254-50.545-45.127-86.205-45.127-57.897 0-105 47.103-105 105s47.103 105 105 105c35.66 0 67.219-17.873 86.205-45.127l116.132 58.066c-3.458 10.4-5.337 21.515-5.337 33.061 0 57.897 47.103 105 105 105s105-47.103 105-105-47.103-105-105-105zm0-272c41.355 0 75 33.645 75 75s-33.645 75-75 75-75-33.645-75-75 33.645-75 75-75zm-302 301c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75zm302 151c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75z"/>
                </g>
              </svg>
            </button>
          </div>
          <div id="showMessage"
               style="width: 14rem; font-size: 0.8rem; margin-top: 0.5rem; font-weight: lighter !important;"></div>
        </div>
        <div class="col-lg-1 d-none d-sm-block"></div>

        <div class="col-sm-12 col-lg-4 pt-3">
          <div class="row lot-specs">
            <div v-bind:class="{'col-10':details.hasTreasure,'col-12':!details.hasTreasure}">
              <h1 class="h2 font-weight-bold" v-html="details.whole_title"></h1>
            </div>

            <div class="col-2" v-if="details.hasTreasure">
              <form action="/treasureHuntFound" method="get"><input type="hidden" name="lot_id"
                                                                    :value="details.id"/>
                <button type="submit" class="p-0 border-0"><img width="128px"
                                                                src="/assets/img/promo1.jpg"/></button>
              </form>
            </div>

            <div class="col-12 my-1"
                 v-if="auction.order == 400 && details.number == 46 && details.manufacturer">
              <span>{{ details.manufacturer }}</span>
            </div>
            <div class="col-12 my-1" v-for="(artist, index) in details.artists" :key="index">
              <span
                  v-if="auction.category_id!==51 && auction.category_id!==16 && details.manufacturer"
              >{{ details.manufacturer }}</span>

              <div class="h4 m-0 font-weight-bold row">
                                <span class="row-artist"
                                      v-if="(auction.id == 845 && details.number == 46)">{{
                                    details.manufacturer
                                  }}</span>
                <span class="row-artist" v-html="makeArtistLink(artist)"></span>
                <span class="row-artist"
                      v-if="(artist.type===2 && auction.category_id!==51 && auction.category_id!==16 && details.manufacturer)">{{
                    details.manufacturer
                  }}</span>
                <span class="row-artist"
                      v-else-if="(auction.id == 845 && details.number == 46)">{{ details.manufacturer }}</span>
                <div v-if="!isFollowed &&(details.artists && details.artists[0] && details.artists[0].type === 1)"
                     id="follow-artist" @click="followArtist"
                     class="row" style="margin-left: 1rem;">
                  <svg enable-background="new 0 0 512 512" height="15" viewBox="0 0 512 512"
                       style="margin-top: 0.3rem;"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341
                                            c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z
                                            "/>
                    <path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318
                                            c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83
                                            s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/>
                  </svg>
                  <h6 style=" margin-left: 0.3rem; margin-top: 0.41rem;  font-weight: 700 !important; font-size: 0.8rem !important;">
                    {{ followArtistText }}</h6>
                </div>
                <div v-if="isFollowed" id="unfollow-artist" @click="unfollowArtist"
                     class="row" style="margin-left: 1rem;">
                  <svg enable-background="new 0 0 512 512" height="15" viewBox="0 0 512 512"
                       style="margin-top: 0.3rem;"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M238.933,0C106.974,0,0,106.974,0,238.933s106.974,238.933,238.933,238.933s238.933-106.974,238.933-238.933
                                        C477.726,107.033,370.834,0.141,238.933,0z M238.933,443.733c-113.108,0-204.8-91.692-204.8-204.8s91.692-204.8,204.8-204.8
                                        s204.8,91.692,204.8,204.8C443.611,351.991,351.991,443.611,238.933,443.733z"/>
                    <path d="M370.046,141.534c-6.614-6.388-17.099-6.388-23.712,0v0L187.733,300.134l-56.201-56.201
                                        c-6.548-6.78-17.353-6.967-24.132-0.419c-6.78,6.548-6.967,17.353-0.419,24.132c0.137,0.142,0.277,0.282,0.419,0.419
                                        l68.267,68.267c6.664,6.663,17.468,6.663,24.132,0l170.667-170.667C377.014,158.886,376.826,148.082,370.046,141.534z"/>
                  </svg>
                  <h6 style=" margin-left: 0.3rem; margin-top: 0.41rem; font-weight: 700 !important; font-size: 0.8rem !important;">
                    {{ artistFollowedText }} </h6>
                </div>
                <div class="w-100 ">
                  <div class="iziToast-wrapper-artist"></div>
                </div>
              </div>
              <div class="m-0 text-muted"
                   v-if="artist.birth_date && artist.birth_date != 0 && auction.category_id!==51">
                                <span v-if="artist.death_date && artist.death_date != 0">
                                    {{ artist.birth_date }}<span
                                    v-if="artist.birth_place">, {{ artist.birth_place }}</span> -
                                    {{ artist.death_date }}<span
                                    v-if="artist.death_place">, {{ artist.death_place }}</span>
                                </span>
                <span v-else>
                                    <span
                                        v-if="new Date().getFullYear()-artist.birth_date<=100">{{
                                        __('born-prefix')
                                      }}</span>{{ artist.birth_date }}<span
                    v-if="artist.birth_place">, {{ artist.birth_place }}</span>
                                </span>
              </div>
            </div>

            <div class="col-1 my-1" v-for="(badge, badge_name) in details.badges" :key="badge_name">
              <img :src="badge" width="30px" height="30px" style="margin-top: 3px;"
              />
            </div>
            <div class="col-1 my-1" v-if="details.is_charitable">
              <img src="/assets/img/Inima_caritabile.png"
                   width="30px"/>
            </div>

            <!--                        <div class="col-12 my-1"-->
            <!--                             v-if="auction.id == 811 && (details.number == 16 || details.number == 17 || details.number == 18 || details.number == 23 || details.number == 24 || details.number == 28 || details.number == 29 || details.number == 30 || details.number == 34 || details.number == 35 || details.number == 36 || details.number == 40 || details.number == 41 || details.number == 42 || details.number == 145 || details.number == 146 || details.number == 147 || details.number == 148 || details.number == 149 || details.number == 150)">-->
            <!--                            <img src="/assets/img/LOGO-VETERANI.png" width="32px" class="float-right"/>-->
            <!--                        </div>-->
            <!--                        <div class="col-12 my-1"-->
            <!--                             v-else-if="auction.id == 834 && details.number  == 43">-->
            <!--                            <img src="/assets/img/carturesti.png"-->
            <!--                                 width="70px" style="margin-top: -17px; margin-right: 10px;"-->
            <!--                                 class="float-right"-->
            <!--                            />-->
            <!--                            <img src="/assets/img/logo_ovr.png"-->
            <!--                                 width="70px" style="margin-top: -17px; margin-right: 10px;"-->
            <!--                                 class="float-right"-->
            <!--                            />-->
            <!--                            <img src="/assets/img/Inima_caritabile.png"-->
            <!--                                 width="32px"-->
            <!--                                 class="float-right"-->
            <!--                            />-->
            <!--                        </div>-->
            <!--                        <div class="col-12 my-1"-->
            <!--                             v-else-if="auction.id == 845 && (details.number  == 37 || details.number  == 38 || details.number  == 39)">-->
            <!--                            <img src="/assets/img/Inima_caritabile.png"-->
            <!--                                 width="35px" style="margin-top: -17px; margin-right: 10px;"-->
            <!--                                 class="float-right"-->
            <!--                            />-->
            <!--                            <img src="/assets/img/pentru-luca.png"-->
            <!--                                 width="35px" style="margin-top: -17px; margin-right: 10px;"-->
            <!--                                 class="float-right"-->
            <!--                            />-->
            <!--                        </div>-->
            <!--                        <div class="col-12 my-1"-->
            <!--                             v-else-if="(auction.id == 852 && (details.number >= 134 && details.number <=141))">-->
            <!--                            <img src="/assets/img/Inima_caritabile.png"-->
            <!--                                 width="35px" style="margin-top: -17px; margin-right: 10px;"-->
            <!--                                 class="float-right"-->
            <!--                            />-->
            <!--                            <img src="/assets/img/logo-anais.png"-->
            <!--                                 width="32px" style="margin-top: -17px; margin-right: 10px;"-->
            <!--                                 class="float-right"-->
            <!--                            />-->
            <!--                        </div>-->
            <!--                        <div class="col-12 my-1"-->
            <!--                             v-else-if="auction.id == 846 && (details.number  == 10)">-->
            <!--                            <img src="/assets/img/Inima_caritabile.png"-->
            <!--                                 width="35px" style="margin-top: -17px; margin-right: 10px;"-->
            <!--                                 class="float-right"-->
            <!--                            />-->
            <!--                        </div>-->
            <!--                        <div class="col-12 my-1"-->
            <!--                             v-else-if="auction.id == 860 && (details.number  == 7 || details.number  == 8 || details.number  == 11 || details.number  == 13 || details.number  == 100 || details.number  == 123 || details.number  == 133 || details.number  == 141 || details.number  == 150 || details.number  == 153 || details.number  == 156 || details.number  == 160 || details.number  == 161 || details.number  == 171 || details.number  == 177 || details.number  == 179 || details.number  == 180 || details.number  == 192 || details.number  == 55 || details.number  == 57)">-->
            <!--                            <img src="/assets/img/Inima_caritabile.png"-->
            <!--                                 width="35px" style="margin-top: -17px; margin-right: 10px;"-->
            <!--                                 class="float-right"-->
            <!--                            />-->
            <!--                        </div>-->
            <!--                        <div class="col-12 my-1"-->
            <!--                             v-else-if="auction.id == 853 && (details.number  == 16 ||-->
            <!--details.number  == 17 ||-->
            <!--details.number  == 18 ||-->
            <!--details.number  == 46 ||-->
            <!--details.number  == 47 ||-->
            <!--details.number  == 48 ||-->
            <!--details.number  == 49 ||-->
            <!--details.number  == 50 ||-->
            <!--details.number  == 51 ||-->
            <!--details.number  == 67 ||-->
            <!--details.number  == 68 ||-->
            <!--details.number  == 69 ||-->
            <!--details.number  == 70 ||-->
            <!--details.number  == 71 ||-->
            <!--details.number  == 72 ||-->
            <!--details.number  == 100 ||-->
            <!--details.number  == 102 ||-->
            <!--details.number  == 103 ||-->
            <!--details.number  == 104 ||-->
            <!--details.number  == 105 ||-->
            <!--details.number  == 151 ||-->
            <!--details.number  == 152 ||-->
            <!--details.number  == 153-->
            <!--)">-->
            <!--                            <img src="/assets/img/Inima_caritabile.png"-->
            <!--                                 width="35px" style="margin-top: -17px; margin-right: 10px;"-->
            <!--                                 class="float-right"-->
            <!--                            />-->
            <!--                            <img src="/assets/img/logo-hospice.png"-->
            <!--                                 width="35px" style="margin-top: -17px; margin-right: 10px;"-->
            <!--                                 class="float-right"-->
            <!--                            />-->
            <!--                        </div>-->
            <!--                        <div class="col-12 my-1"-->
            <!--                             v-else-if="details.is_charitable">-->
            <!--                            <img src="/assets/img/Inima_caritabile.png"-->
            <!--                                 width="35px" style="margin-top: -17px; margin-right: 10px;"-->
            <!--                                 class="float-right"-->
            <!--                            />-->
            <!--                        </div>-->

            <div class="col-12 h4 m-0" v-if="!details.artists && details.old_artist">
              <!-- Daca nu e vin, si nu am artist, dar am artist vechi(Fallback)  -->
              {{ details.old_artist }}
            </div>
            <div class="col-12"> <!-- Separator dupa toate informatiile astea -->
              <hr class="my-3"/>
            </div>

            <!-- Auction live -->
            <div class="col-12 h4" v-if="settings && auction.auction_is_live !== 0">
              <a :href="artmarkLive">
                <p class="live_status d-inline auction_live_now h7 p-2 m-0 float-left"><strong>{{
                    __LIVE('auction-is-live')
                  }}</strong></p>
              </a>
            </div>
            <div class="col-12" v-for="(price, price_name) in details.prices_single" :key="price_name">
              <span class="font-weight-bold text-uppercase" id="price_name">
                 <span v-html="price_name">{{ price_name }}</span>
              </span>
              <span
                  v-if="details.is_fapte_bune != 'FB' && details.live_price > 0 && (details.auction.mode == 4 || details.auction.mode == 5) && auction.offer_status === 2"
                  class="font-weight-bold text-uppercase">
                <span class="text-uppercase" v-if="highest_bidder == loggedInId">({{ __("highest-bidder") }})</span>
                <span class="text-uppercase" v-else-if="user_has_bids_on_lot"> ({{ __("out-bidden") }})</span>
              </span>
              <br v-if="price != null"/>
              <span v-html="price" id="price_value">
                            {{ price }}
                                </span>
              <br/>
              <hr class="my-3"/>
            </div>
            <!--                            <button @click="placeOfferPostAuction()"-->
            <!--                                    class="mb-2 btn action_box w-100 action_box_full_width_mobile rounded-0 text-uppercase place-offer-button border-0">-->
            <!--                                {{__('buy_now')}}-->
            <!--                            </button>-->
            <!--                            <div class="iziToast-wrapper-offer w-100"></div>-->
            <!--            <div class="col-12" v-for="(btn, btn_name) in details.buttons_single" :key="btn_name">-->
            <!--              <div v-html="btn">-->
            <!--              </div>-->
            <!--              <hr class="my-3"/>-->
            <!--            </div>-->
            <div class="col-12" v-for="btnType in details.buttons">
              <span v-if="btnType != 'buy-offer'">
                <button type="button" name="button"
                        class="mb-2 btn action_box w-100 action_box_full_width_mobile rounded-0 text-uppercase place-offer-button border-0"
                        :class="makeBtnLabel(btnType).class"
                        v-on:click="callMethodByString(makeBtnLabel(btnType).method, $event)">
                  {{ makeBtnLabel(btnType).label }}
                </button>
              <div class="iziToast-wrapper-offer w-100"></div>
              <hr class="my-3"/>
                </span>
            </div>
            <div class="col-12 " v-if="details.category_id === 13 && details.warranty">
              <span class="font-weight-bold text-uppercase">  {{ __('lot-warranty') }} </span>
              <br/>
              {{ details.warranty }}

            </div>

            <div class="col-12" v-if="details.warranty"> <!-- Separator pe fisa -->
              <hr class="my-3"/>
            </div>

            <!-- <div class="col-12" v-if="auction.offer_status === 3 && details.auction_status === 2 && details.reserve_price">
                <span class="font-weight-bold text-uppercase h6">{{__('reserve-price')}}</span>
                <span class="h6"><br/>&euro; {{details.reserve_price}}</span><br/>
                <span class="h7">{{__('commission-warning')}}</span>
            </div>

            <div class="col-12" v-if="auction.offer_status === 3 && details.auction_status === 2 && details.reserve_price">
                <hr class="my-3"/>
            </div> -->
            <div class="col-12" v-if="details.auction_id == 918 || details.auction_id == 921">
              <span class="font-weight-bold text-uppercase">{{ __('description') }}</span>
              <br/>
              <span class="description-span" style="overflow-wrap: break-word;white-space: pre-line;"
                    v-if="details.medium.length < 700" v-html="details.medium"
              ></span>
              <span v-else-if="details.auction_id == 918" class="description-span"
                    style="overflow-wrap: break-word;white-space: pre-line;">
                                <span style="overflow-wrap: break-word;white-space: pre-line;"
                                      v-html="medium.content"></span>
                                <button class="toggle-more" @click="toggleMore">
                                    <span v-if="medium.more">{{ __('read-more') }}</span>
                                    <span v-else>{{ __('read-less') }}</span>
                                </button>
                            </span>
              <!--                            <span class="description-span">{{ details.medium }}</span>-->
              <!-- Daca nu e colectibil sau vin, ii afisez semnatura -->
              <div class="w-100"> <!-- Separator dupa descriere -->
                <hr class="my-3"/>
              </div>
            </div>
            <div class="col-12"
                 v-if="details.medium && (((details.number == 139 || details.number == 143) && details.auction_id == 929) ||([50, 149, 110, 125].includes(details.number) && details.auction_id == 931)||([116].includes(details.number) && details.auction_id == 941)) ">
              <span class="font-weight-bold text-uppercase">{{ __('description') }}</span>
              <br/>
              <span class="description-span" style="overflow-wrap: break-word;white-space: pre-line;"
                    v-html="details.medium"></span>
              <div class="w-100"> <!-- Separator dupa descriere -->
                <hr class="my-3"/>
              </div>
            </div>
            <!--            <div class="col-12">-->
            <!--              <span class="font-weight-bold text-uppercase">{{ __('medium') }}</span>-->
            <!--              <br/>-->
            <!--              <span class="description-span"-->
            <!--                    v-if="details.category_id!==51 && details.medium && !details.is_fapte_bune">{{-->
            <!--                  details.medium-->
            <!--                }}</span>-->
            <!--              <span class="description-span"-->
            <!--                    v-else-if="details.medium && details.medium.length < 700 && details.is_fapte_bune == 'FB'"-->
            <!--                    v-html="details.medium"-->
            <!--              ></span>-->
            <!--              <span v-else-if="details.medium && details.medium.length > 700 && details.is_fapte_bune == 'FB'"-->
            <!--                    class="description-span">-->
            <!--                                <span v-html="medium.content"></span>-->
            <!--                                <button class="toggle-more" @click="toggleMore">-->
            <!--                                    <span v-if="medium.more">{{ __('read-more') }}</span>-->
            <!--                                    <span v-else>{{ __('read-less') }}</span>-->
            <!--                                </button>-->
            <!--                            </span>-->
            <!--              &lt;!&ndash; Daca nu e vin si nici colectibila, afisez medium &ndash;&gt;-->
            <!--              <span class="description-span"-->
            <!--                    v-if="details.material_carats && (details.category_id===13 || details.category_id===14)">{{-->
            <!--                  details.material_carats-->
            <!--                }}</span>-->
            <!--              <div class="w-100"> &lt;!&ndash; Separator dupa descriere &ndash;&gt;-->
            <!--                <hr class="my-3"/>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="col-12" v-if="((details.id!=56471 && details.id!=56472)&&(
                (details.category_id===12 && (details.id==59652)) ||
                (details.category_id===12 && (details.description !== null && details.medium !== null)&& (details.description !== '' && details.medium !== '')) ||
                ((details.category_id!==51 && details.category_id!==12) && details.description !== '') ||
                (details.material_carats && (details.category_id===13 || details.category_id===14)) ||
                (details.weight && (details.category_id===13 || details.category_id===14)) ||
                (details.width && details.height && details.depth && details.category_id!==51) ||
                (details.category_id!==51 && details.width && details.height) ||
                (details.medium && details.description !== '') ||
                (details.category_id!==51 && details.dimensions) ||
                (details.category_id!==51 && details.signature)))
                && details.auction_id != 918 && details.auction_id != 928 ">
              <!-- Descriere pe lot -->
              <span class="font-weight-bold text-uppercase">{{ __('description') }}</span>
              <br/>

              <!--              <span v-else-if="details.medium && details.medium.length > 700 && details.auction_id == 918"-->
              <!--                    class="description-span">-->
              <!--                                <span v-html="medium.content"></span>-->
              <!--                                <button class="toggle-more" @click="toggleMore">-->
              <!--                                    <span v-if="medium.more">{{ __('read-more') }}</span>-->
              <!--                                    <span v-else>{{ __('read-less') }}</span>-->
              <!--                                </button>-->
              <!--                            </span>-->
              <span class="description-span" style="overflow-wrap: break-word;white-space: pre-line;"
                    v-if="details.medium">{{ details.medium }}</span>
              <!-- Afisez caratajul daca am lotul bijuterie sau decorativ -->
              <span class="description-span"
                    v-if="details.material_carats && (details.category_id===13 || details.category_id===14)">{{
                  details.material_carats
                }}</span>
              <!-- Afisez caratajul daca am lotul bijuterie sau decorativ -->
              <span class="description-span"
                    v-if="details.weight">{{ details.weight }}</span>
              <!-- Afisez greutate daca bijuterie sau decorativa -->
              <span class="description-span"
                    v-if="details.width && details.height && details.depth && details.category_id!==51"> <!-- Daca nu e colectibil sau vin si am cele 3 dimensiuni, le afisez-->
                                {{ details.height }} x {{ details.width }} x {{
                  details.depth
                }} {{ __('measurment-unit') }}</span>
              <span class="description-span"
                    v-if="details.width && details.depth && details.height == null && details.category_id!==51"> <!-- Daca nu e colectibil sau vin si am cele 3 dimensiuni, le afisez-->
                                {{ details.width }} x {{ details.depth }} {{ __('measurment-unit') }}</span>
              <span class="description-span"
                    v-else-if="details.category_id!==51 && details.width && details.height && details.depth == null"> <!-- Daca nu e colectibil sau vin si am latime si inaltime le afisez-->
                                {{ details.height }} x {{ details.width }} {{ __('measurment-unit') }}</span>
              <span class="description-span"
                    v-else-if="details.category_id!==51 && details.dimensions && !details.width && !details.height && !details.depth"> <!-- Daca nu am dimensiunile de mai sus, afisez dimensiune custom -->
                                {{ details.dimensions }}</span>
              <span class="description-span" style="overflow-wrap: break-word;white-space: pre-line;"
                    v-if="details.category_id!==51 && details.signature">{{ details.signature }}</span>
              <!-- Daca nu e colectibil sau vin, ii afisez semnatura -->
              <div class="w-100"> <!-- Separator dupa descriere -->
                <hr class="my-3"/>
              </div>
            </div>
            <div class="col-12" v-else-if="details.id==56471 ||details.id==5647||details.id==70848">
              <!-- Descriere pe lot -->
              <span class="font-weight-bold text-uppercase">{{ __('description') }}</span>
              <br/>
              <span v-if="details.dimensions" class="description-span"> <!-- Daca nu am dimensiunile de mai sus, afisez dimensiune custom -->
                                {{ details.dimensions }}</span>
              <span class="description-span" v-if="details.medium.length < 700"
                    style="overflow-wrap: break-word;white-space: pre-line;" v-html="details.medium"
              ></span>
              <span v-else class="description-span" style="overflow-wrap: break-word;white-space: pre-line;">
                                <span style="overflow-wrap: break-word;white-space: pre-line;"
                                      v-html="medium.content"></span>
                                <button class="toggle-more" @click="toggleMore">
                                    <span v-if="medium.more">{{ __('read-more') }}</span>
                                    <span v-else>{{ __('read-less') }}</span>
                                </button>
                            </span>
              <!--                            <span class="description-span">{{ details.medium }}</span>-->
              <!-- Daca nu e colectibil sau vin, ii afisez semnatura -->
              <div class="w-100"> <!-- Separator dupa descriere -->
                <hr class="my-3"/>
              </div>
            </div>

            <div class="w-100">
              <div class="col-12" style="white-space: pre-line;" v-if="(details.provenance )">
                <!-- Daca nu e colectibil ii afisez provenienta, informatii din cercetari si notele/pe verso -->
                <span class="font-weight-bold text-uppercase">{{ __('provenance') }}</span>
                <br/>
                {{ details.provenance }}
              </div>
              <div class="col-12" v-if="(details.provenance)">
                <!-- Separator daca am informatiile de mai sus -->
                <hr class="my-3"/>
              </div>
              <div class="col-12" v-if="(details.research_info )">
                <!-- Daca nu e colectibil ii afisez provenienta, informatii din cercetari si notele/pe verso -->
                <span class="font-weight-bold text-uppercase">{{ __('research-info') }}</span>
                <br/>
                <div class="description text-justify">
                  <span style="overflow-wrap: break-word;white-space: pre-line;" v-html="details.research_info"></span>
                </div>
              </div>
              <div class="col-12" v-if="(details.research_info)">
                <!-- Separator daca am informatiile de mai sus -->
                <hr class="my-3"/>
              </div>
              <div class="col-12" v-if="(details.notes )">
                <!-- Daca nu e colectibil ii afisez provenienta, informatii din cercetari si notele/pe verso -->
                <span class="font-weight-bold text-uppercase">{{ __('on-the-back') }}</span>
                <br/>
                {{ details.notes }}
              </div>
              <div class="col-12" v-if="(details.notes)">
                <!-- Separator daca am informatiile de mai sus -->
                <hr class="my-3"/>
              </div>
            </div>


            <div v-if="details.description" class="col-12"> <!-- Daca nu e colectibil ii afisez fisa -->
              <span class="font-weight-bold text-uppercase">{{ __('full-description') }}</span>
              <br/>
              <!--
              <div v-html="trim(details.description)" v-if="details.description.length<700"></div>
              <div class="col-12" v-else>
                  <input type="checkbox" class="read-more-state d-none" id="post-1"/>
                  <span class="read-more-wrap">
                    {{ details.description.substring(0,700) }}
                    <span class="read-more-target">{{ details.description.substring(700) }}<br/></span>
                  </span>
                  <label for="post-1" class="h7 read-more-trigger">Mult mai mult</label>
              </div>
              -->
              <div v-if="details.description.length < 700" v-html="details.description"
                   class="description text-justify"
              ></div>
              <div v-else class="description text-justify">
                <span style="overflow-wrap: break-word;white-space: pre-line;" v-html="description.content"></span>
                <button class="toggle-more" @click="toggleMore">
                  <span v-if="description.more">{{ __('read-more') }}</span>
                  <span v-else>{{ __('read-less') }}</span>
                </button>
              </div>
            </div>

            <div class="col-12" v-if="details.description"> <!-- Separator pe fisa -->
              <hr class="my-3"/>
            </div>

            <div v-if="details.bio && details.category_id!==51" class="col-12">
              <!-- Daca nu e colectibil si nici vin, ii afisez bio-ul/eseu -->
              <span class="font-weight-bold text-uppercase">{{ __('bio') }}</span>
              <br/>
              <div style="overflow-wrap: break-word;white-space: pre-line;" v-html="details.bio"></div>
            </div>
            <div class="col-12" v-if="details.bio && details.category_id!==51">
              <hr class="my-3"/>
            </div>


            <div class="col-12">
              <span class="font-weight-bold text-uppercase">{{ __('extra-info') }}</span>
              <br/>
              <span v-if="!details.is_fapte_bune && details.auction_id != 944 && details.auction_id != 1119"><span
                  class="h7 text-justify">{{ __('preserved-state-mail') }}</span>
                            <u>
                                <a class="h7"
                                   :href="makeConservationString()">{{
                                    __('here-preserved')
                                  }}</a>.
                            </u>
                            <br/></span>

              <span v-if="details.auction_id == 1119" class="h7"><span class="h7">{{
                  __('preserved-state-mail-gold')
                }}</span>
                            <u>
                                <a class="h7"
                                   :href="'mailto:infoconservare@artmark.ro?subject=Cerere informații despre starea de conservare Lot ' + details.number + ' / Licitația L' + auction.order +
                                    '&body=Lot ' + details.number + ', ' + details.title + ' - ' + currentPage">{{
                                    __('here-preserved')
                                  }}</a>.
                            </u>
                            <br/></span>
              <span v-if="details.auction_id == 944" class="h7"><span class="h7">{{
                  __('preserved-state-coins')
                }}</span>
                            <u>
                                <a class="h7"
                                   :href="'mailto:infoconservare@artmark.ro?subject=Cerere informații despre starea de conservare Lot ' + details.number + ' / Licitația L' + auction.order +
                                    '&body=Lot ' + details.number + ', ' + details.title + ' - ' + currentPage">{{
                                    __('here-preserved')
                                  }}</a>.
                            </u>
                            <br/></span>
              <div v-for="(rule) in details.auctioning_rules">
                <span class="h7" v-html="rule.name"></span><br/>
                <div class="h7 text-justify" v-if="rule.mentions" v-html="rule.mentions"></div>

              </div>
              <span
                  v-if="details.auction_id == 928 && [150, 151, 152, 153, 154, 155, 156, 157, 158, 226, 227, 228, 229, 230].includes(details.number) "
                  class="h7">{{ __('preserved-state-mail-alcool') }} </span>

              <br/>
              <div class="h7">{{ __('preserved-state') }}</div>
              <span class="h7">  <a
                  :href="locale() === 'ro' ? '/ro/consultanti' : (locale() === 'en' ? '/en/consultants' : (locale() === 'bg' ? '/bg/consultants' : (locale() === 'hr' ? '/hr/savjetnici' : '')))"><u>{{
                  __('preserved-state-link')
                }}</u></a>
                <span v-if="details.auction_id == 1119 ">
                  <span
                      class="h7">{{ __('or') }}</span>
                <span
                    class="h7"><a
                    :href="locale() === 'ro' ? '/ro/rules-608' : (locale() === 'en' ? '/en/rules-608' : (locale() === 'bg' ? '/bg/rules-608' : (locale() === 'hr' ? '/hr/rules-608' : '')))"><u>{{
                    __('or-click-guide')
                  }}</u></a> </span>
                  </span>
                  </span>
              <br/>


            </div>

            <div class="col-12" v-if="auction.start_date"> <!-- Separator pe data de start la licitatie -->
              <hr class="my-3"/>
            </div>
            <div class="col-12" v-if="auction.start_date">
              <!-- Daca am data de start la licitatie, o afisez -->
              <span class="font-weight-bold text-uppercase">{{ __('session') }}</span>
              <br/>
              <span class="text-lowercase">
                {{ auction.display_start_date }}
              </span>
            </div>

            <div class="col-12" v-if="![3,4,6,21,32,26,80].includes(details.auction_status)">
              <!-- offers pre auction (2) -->
              <div class="w-100" v-if="auction.offer_status === 2">
                <hr class="my-3"/>
              </div>
              <div
                  v-if="auction.offer_status === 2 && (details.auction_status !=3 && details.auction_status != 4 && details.auction_status != 1 && details.auction_status != 5)">

                <div class="w-100 pb-2 h6 m-0 text-muted mb-2" v-if="auction.offer_status === 2">
                  <span v-if="dif!==0"
                        class="font-weight-bold text-uppercase text-dark">{{ __('time-remaining') }}</span><br/>
                  <VueCountdown :key="auction.display_start_timestamp" :time="dif" v-if="dif!==0" class="font-italic">
                    <template slot-scope="props"><span v-if="trimZero(props.days)!==0">{{
                        trimZero(props.days)
                      }} {{ __('days') }}, </span><span
                        v-if="trimZero(props.hours)!==0 || trimZero(props.days)!==0">{{
                        trimZero(props.hours)
                      }} {{ __('hours') }}, </span>{{
                        trimZero(props.minutes)
                      }}
                      {{ __('minutes') }}
                    </template>
                  </VueCountdown>
                  <div v-else>
                    <!--{{__('countdown-ended')}}-->
                  </div>
                </div>

                <form>
                  <!-- NOT timed -->
                  <template v-if="details.auction.mode != 4 && details.auction.mode != 5">
                    <input
                        autocomplete="off"
                        name="details-offer-amount"
                        type="text"
                        v-model="offerValue"
                        ref="placeOffer"
                        class="chrome-autofill-hack form-control bg-light myAccount-form-control-custom pl-0"
                        id="offer_value"
                        :placeholder="__('amount')"
                    />

                    <button
                        :class="{ disabled: !validated || approval_status === 5 }"
                        @click="placeOffer(); gtag_report_conversion('https://www.artmark.ro/');"
                        class="mb-2 btn action_box w-100 action_box_full_width_mobile rounded-0 text-uppercase place-offer-button border-0"
                        type="button"
                    >
                      <span v-if="details.is_fapte_bune == 'FB'">{{ __('donate') }}</span>
                      <span v-else>{{ __('place-offer') }}</span>
                    </button>
                  </template>

                  <!--timed -->
                  <template v-else>
                    <!-- dropdown + place-offer only if lot is pending -->
                    <template v-if="details.auction_status == 0">
                      <select
                          v-model="offerValue"
                          class="form-control search myAccount-form-control-custom input__placeholder"
                      >
                        <option disabled hidden value="">{{ __('select_amount') }}</option>
                        <option v-for="step in biddingSteps.next" :key="step" :value="step">
                          {{ step }}
                        </option>
                      </select>

                      <button
                          :class="{ disabled: !validated || approval_status === 5 }"
                          @click="placeOffer(); gtag_report_conversion('https://www.artmark.ro/');"
                          class="mb-2 btn action_box w-100 action_box_full_width_mobile rounded-0 text-uppercase place-offer-button border-0"
                          type="button"
                      >
                        <span v-if="details.is_fapte_bune == 'FB'">{{ __('donate') }}</span>
                        <span v-else>{{ __('place-offer') }}</span>
                      </button>
                    </template>

                    <!-- ALWAYS potentially show live link in timed -->
                    <a
                        v-if="details.auction.live_status == 1"
                        :href="'/' + locale() + '/live/' + details.auction.id"
                        class="mb-2 btn action_box w-100 action_box_full_width_mobile rounded-0 text-uppercase place-offer-button border-0"
                        type="button"
                    >
                      <span>{{ __('go-to-live-auction') }}</span>
                    </a>
                  </template>
                </form>


                <div class="iziToast-wrapper-offer w-100"></div>
              </div>

              <!-- offers post auction (3) -->
              <!-- <div v-if="auction.offer_status === 2">
                  <div class="h4" v-if="details.auction_status == 2">
                      <input autocomplete="off" type="text" v-model="offerValue"
                             class="chrome-autofill-hack form-control bg-light myAccount-form-control-custom"
                             id="offer_value_modal"
                             :placeholder="__('amount')"
                      />
                      <button :class="{'disabled':!validated}"
                              @click="placeOffer(); gtag_report_conversion('https://www.artmark.ro/');"
                              class="mb-2 btn action_box w-100 action_box_full_width_mobile rounded-0 text-uppercase place-offer-button border-0"
                      >{{__('place-offer')}}
                      </button>

                      <div class="iziToast-wrapper-offer w-100"></div>
                  </div>
              </div> -->
              <div class="d-flex w-100">
                <a :href="amLiveLink" v-if="this.auction.mode != 4 && this.auction.mode != 5"
                   class="h6 w-25 d-flex justify-content-start text-muted nounderline mr-3"><u>{{
                    __('bid-online')
                  }}</u></a>
                <a :href="amLiveTimedLink" target="_blank" v-else
                   class="h6 w-25 d-flex justify-content-start text-muted nounderline mr-3"><u>{{
                    __('bid-online')
                  }}</u></a>
                <a :href="howToSellUrl"
                   class="h6 w-75 d-flex justify-content-end text-muted nounderline"
                   :aria-label="__('saleoffer')"><u>{{ __('saleoffer') }}</u></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Root element of PhotoSwipe. Must have class pswp. -->
    <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="pswp__bg"></div>

      <!-- Slides wrapper with overflow:hidden. -->
      <div class="pswp__scroll-wrap">

        <!-- Container that holds slides.
            PhotoSwipe keeps only 3 of them in the DOM to save memory.
            Don't modify these 3 pswp__item elements, data is added later on. -->
        <div class="pswp__container">
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
        </div>

        <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
        <div class="pswp__ui pswp__ui--hidden">

          <div class="pswp__top-bar">

            <!--  Controls are self-explanatory. Order can be changed. -->

            <div class="pswp__counter"></div>

            <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

            <button class="pswp__button pswp__button--share" title="Share"></button>

            <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

            <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

            <!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR -->
            <!-- element will get class pswp__preloader--active when preloader is running -->
            <div class="pswp__preloader">
              <div class="pswp__preloader__icn">
                <div class="pswp__preloader__cut">
                  <div class="pswp__preloader__donut"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
            <div class="pswp__share-tooltip"></div>
          </div>

          <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
          </button>

          <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
          </button>

          <div class="pswp__caption">
            <div class="pswp__caption__center"></div>
          </div>

        </div>

      </div>

    </div>

    <!-- Login Modal -->
    <div v-if="loginModal" class="modal show-modal show fade p-0" id="loginModal" tabindex="-1" role="dialog"
         aria-labelledby="loginModal" aria-hidden="true" ref="loginModal" style="z-index:10000;">

      <div class="modal-dialog modal-dialog-centered modal-lg" role="login">
        <div class="modal-content rounded-0">
          <div class="modal-header">
            <h4 class="modal-title h5">{{ __('api-unauthenticated') }}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    @click="loginModal=false">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="row py-5">s
            <div class="d-flex px-5">
              <div v-if="!loadingLogin"
                   class="col-lg-4 border-right border-grey center-vertically d-none d-lg-flex">
                <img src="/assets/img/mya10account/sign_in.jpg" class="img-fluid"/>
              </div>
              <div v-if="loadingLogin" class="d-flex w-100 loader center-vertically my-5">
                <svg version="1.1" id="da-loader" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px"
                     height="40px"
                     viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
              <path fill="#000"
                    d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path>
            </svg>
              </div>
              <div class="col-12 col-lg-8">
                <h5 class="h5 text-center text-muted my-4 px-3">{{ __('login') }}</h5>
                <div class="px-3 row" v-if="!loadingLogin">

                  <div class="col-12 form-group">
                    <input
                        ref="username_login"
                        id="username_login"
                        class="chrome-autofill-hack form-control bg-light myAccount-form-control-custom"
                        type="email" placeholder=" " required autofocus/>
                    <label class="form-control-placeholder" for="username_login">
                      <span>{{ __('email') }}</span>
                    </label>
                  </div>
                  <div class="col-12 form-group">
                    <input ref="password_login" id="password_login"
                           class="chrome-autofill-hack form-control bg-light myAccount-form-control-custom"
                           type="password" placeholder=" " required/>
                    <label class="form-control-placeholder" for="password_login">
                      <span>{{ __('Password') }}</span>
                    </label>
                  </div>
                  <div class="col-12 d-flex justify-content-center mt-4">
                    <button @click="loginUser()" type="button"
                            class="btn action_box w-100 action_box_full_width_mobile rounded-0"
                    >{{ __('login') }}
                    </button>

                  </div>

                </div>
                <div class="w-100 px-2">
                  <div class="iziToast-wrapper-modal px-2"></div>
                </div>
                <div class="col-12">
                  <a
                      class="btn btn-link text-dark nounderline pl-0"
                      :href="route('forgot')"
                  >{{ __('forgot-pass') }}</a>
                </div>
                <div class="col-12 d-flex pt-4">
                  <a class="h6 nounderline"
                     :href="route('register')">{{ __('no-account-register') }}</a>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" role="dialog" id="favoritesModal">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ __('favorites-modal') }}</h5>
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 0 !important;">
            <div class="col-12">
              <h5 class="h5 text-center text-muted my-4 px-3">{{ __('login') }}</h5>
              <div class="px-3 row" v-if="!loadingLogin">
                <div class="col-12 form-group">
                  <input ref="username_login" id="username_login"
                         class="chrome-autofill-hack form-control bg-light myAccount-form-control-custom"
                         type="email" placeholder=" " required autofocus/>
                  <label class="form-control-placeholder" for="username_login">
                    <span>{{ __('email') }}</span>
                  </label>
                </div>
                <div class="col-12 form-group">
                  <input ref="password_login" id="password_login"
                         class="chrome-autofill-hack form-control bg-light myAccount-form-control-custom"
                         type="password" placeholder=" " required/>
                  <label class="form-control-placeholder" for="password_login">
                    <span>{{ __('Password') }}</span>
                  </label>
                </div>
                <div class="col-12 d-flex justify-content-center mt-4">
                  <button @click="loginUser()" type="button"
                          class="btn action_box w-100 action_box_full_width_mobile rounded-0">
                    {{ __('login') }}
                  </button>

                </div>

              </div>
              <div class="w-100 px-2">
                <div class="iziToast-wrapper-modal px-2"></div>
              </div>
              <div class="col-12">
                <a class="btn btn-link text-dark nounderline pl-0"
                   :href="route('forgot')">{{ __('forgot-pass') }}</a>
              </div>
              <div class="col-12 d-flex pt-4">
                <a class="h6 nounderline" :href="route('register')">{{ __('no-account-register') }}</a>
              </div>

            </div>
          </div>
          <div class="modal-footer">
          </div>
        </div>
      </div>
    </div>
    <v-tour name="tourArtist" :steps="stepsArtist" :options="myOptions">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
              v-if="tour.steps[tour.currentStep]"
              :key="tour.currentStep"
              :step="tour.steps[tour.currentStep]"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :skip="tour.skip"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels" style="background: #343a40 !important;"
          >
          </v-step>
        </transition>
      </template>
    </v-tour>
    <v-tour name="tourNoArtist" :steps="stepsNoArtist" :options="myOptions">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
              v-if="tour.steps[tour.currentStep]"
              :key="tour.currentStep"
              :step="tour.steps[tour.currentStep]"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :skip="tour.skip"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels" style="background: #343a40 !important;"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button @click="tour.stop" class="v-step__button v-step__button-stop">
                  {{ __('buttonStop') }}
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>
<script>

const throttle = (func, limit) => {
  let inThrottle;
  return function () {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

import VueCountdown from "@xkeshi/vue-countdown";
import Swiper from "swiper";

export default {
  components: {
    VueCountdown,
  },
  data: function () {
    return {
      currentLotNumber: null,
      currentLotPollTimer: null,
      loading: false,
      loadingLogin: false,
      details: {},
      biddingSteps: {},
      user_has_bids_on_lot: false,
      highest_bidder: false,
      lotJump: "",
      offerValue: "",
      hasError: false,
      currentAuction: {
        name: null,
        slug: null
      },
      validated: true,
      loginModal: false,
      updatedCount: 0,
      loadedFullImages: false,
      pswp_init: false,
      confirm_sync: false,
      syncing: false,
      more: false,
      titleFav: window.AG.locale == 'ro' ? 'Adaugă la favorite' : 'Add to favorites',
      titleUnfav: window.AG.locale == 'ro' ? 'Elimină de la favorite' : 'Remove from favorites',
      titleFollow: window.AG.locale == 'ro' ? 'Urmărește artistul și noi te vom anunța atunci când o operă de-a sa este pusă la licitație' :
          'Follow this artist and we will let you know when an artwork is added in auction',
      followArtistText: window.AG.locale == 'ro' ? 'Urmărește artistul' : 'Follow artist',
      artistFollowedText: window.AG.locale == 'ro' ? 'Artist adăugat' : 'Artist added',
      type: "",
      isFavorite: null,
      isFollowed: null,
      stepsArtist: [
        {
          target: '#follow-artist',
          content: window.AG.locale == 'ro' ? "Urmărește artistul și noi te anunțăm când intră în licitație!" : "Follow artist and we'll let you know when it comes up in auction!",
        },
        {
          target: '#btn-unfavorite',
          content: window.AG.locale == 'ro' ? 'Click și opera ajunge în secțiunea de Favorite iar noi te anunțăm când intră în licitație!' : "Click and we'll add it to Favorites and warn you before the auction!",
          offset: -100,
          params: {
            placement: 'bottom',
            enableScrolling: true
          }
        }
      ],
      stepsNoArtist: [
        {
          target: '#btn-unfavorite',
          content: window.AG.locale == 'ro' ? 'Click și opera ajunge în secțiunea de Favorite iar noi te anunțăm când intră în licitație!' : "Click and we'll add it to Favorites and warn you before the auction!",
          offset: -100,
          params: {
            placement: 'bottom',
            enableScrolling: true
          }
        }
      ],
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: window.AG.locale == 'ro' ? 'Sari peste tur' : 'Skip the tour',
          buttonPrevious: window.AG.locale == 'ro' ? 'Pasul anterior' : 'Previous step',
          buttonNext: window.AG.locale == 'ro' ? 'Vezi pasul următor' : 'Next step',
          buttonStop: window.AG.locale == 'ro' ? 'Am înțeles!' : 'Got it!'
        }
      },
      customOptions: {
        enabledButtons: {
          buttonSkip: false,
          buttonPrevious: true,
          buttonNext: true,
          buttonStop: true
        },
      },
      conservationStatusEmails: {
        ro: 'infoconservare@artmark.ro',
        bg: 'conservationstatus@artmark.bg',
        hr: 'info.konzervacija@artmark.hr',
      },

    };
  },
  props: ["lot", "goToOffer", "token", "user", "single"],
  methods: {
    makeArtistLink: function (artist) {
      if (artist.has_page) {
        return '<a href="/' + this.locale() + '/artist/' + artist.slug + '" style="text-decoration: underline">' + artist.name + '</a>';
      } else {
        return artist.name
      }

    },
    getBiddingSteps: function () {
      axios({
        method: "get",
        url: "/api/lot-bidding-steps",
        params: {id: this.details.id},
        config: {
          headers: {
            "Content-Type": "application/json"
          }
        }
      }).then(response => {
        this.biddingSteps = response.data;
      }).catch(error => {
      });
    },
    getHighestBidder: function () {
      axios({
        method: "get",
        url: "/api/lot-highest-bidder",
        params: {id: this.details.id},
        config: {
          headers: {
            "Content-Type": "application/json"
          }
        }
      }).then(response => {
        this.highest_bidder = response.data.user_id
      }).catch();
    },
    checkFavorites: function () {
      axios({
        method: "get",
        url: "/api/check-favorites",
        params: {type: 'lot', id: this.details.id},
        config: {
          headers: {
            "Content-Type": "application/json"
          }
        }
      }).then(response => {
        this.isFavorite = response.data.isFav;
      }).catch(error => {
        this.validate();
        this.hasError = true;
        if (error.response.status !== 401) {
          window.showToast(
              error.response.data.message,
              "error",
              null,
              ".iziToast-wrapper-offer"
          );
        } else {
          location.reload();
        }
      });
      if (this.details.artists[0]) {
        axios({
          method: "get",
          url: "/api/check-favorites",
          params: {type: 'artist', id: this.details.artists[0].id},
          config: {
            headers: {
              "Content-Type": "application/json"
            }
          }
        }).then(response => {
          this.isFollowed = response.data.isFav;
        }).catch(error => {
          this.validate();
          this.hasError = true;
          if (error.response.status !== 401) {
            window.showToast(
                error.response.data.message,
                "error",
                null,
                ".iziToast-wrapper-offer"
            );
          } else {
            location.reload();
          }
        });
      }
    },
    userHasBids: function () {
      axios({
        method: "get",
        url: "/api/lot-user-has-bids",
        params: {id: this.details.id, userId: this.loggedInId},
        config: {
          headers: {
            "Content-Type": "application/json"
          }
        }
      }).then(response => {
        this.user_has_bids_on_lot = response.data
      }).catch();
    },
    setupPusher: function () {
      if (this.loggedInId && this.approval_status == 2) {

        window.auctionPresenceChannel = Echo.join(`auction.${window.AG.auction.id}`)

        auctionPresenceChannel

            .here((members) => {

            })

            .joining((member) => {

            })

            .leaving((member) => {

            })

            .error((error) => {

            });

        Echo.encryptedPrivate(`bidders.auction.${window.AG.auction.id}`)
            .listen('.bid.win', (e) => {
              if ((window.AG.auction.mode == 4 || window.AG.auction.mode == 5) && e.lid == this.details.id) {
                this.details.live_price = e.p;
                this.details.live_ask_price = e.k;
                $('#price_name').text(this.__("current-price"))
                $('#price_value').text('€ ' + e.p)
                this.getBiddingSteps();
                this.userHasBids();
                this.getHighestBidder();
              }
            })

      } else {

        window.auctionPresenceChannel = false

        Echo.channel(`guests.auction.${window.AG.auction.id}`)

            .listen('.bid.win', (e) => {
              if ((window.AG.auction.mode == 4 || window.AG.auction.mode == 5) && e.lid == this.details.id) {
                this.details.live_price = e.p;
                this.details.live_ask_price = e.k;
                $('#price_name').text(this.__("current-price"))
                $('#price_value').text('€ ' + e.p)
                this.getBiddingSteps();
              }
            })
      }
    },
    callMethodByString: function (methodString, event) {
      this[methodString](event);
    },
    makeBtnLabel: function (btnType) {
      let result = [];
      switch (btnType) {
        case 'buy-offer':
          result['label'] = this.details.is_fapte_bune == 'FB' ? this.__('donate') : this.__('place-offer-call-to-action');
          result['method'] = 'goToOffer';
          result['class'] = 'btn-buy-offer';
          break;
        case 'buy-post':
          result['label'] = this.__("buy_now");
          result['method'] = 'placeOfferPostAuction';
          result['class'] = 'btn-buy-post';
          break;
        case 'buy-shop':
          result['label'] = this.__("buy_shop");
          result['method'] = 'goToShop';
          result['class'] = 'btn-buy-shop';
          break;
      }
      return result;
    },
    goToShop: function (event) {
      window.open(this.details.shop_url, '_blank');
    },
    buyNow: throttle(function () {
      if (this.approval_status === 2) {
        var product_id = this.details.id;
        axios
            .get("/api/buy-now", {
              //.get("/api/offer", {
              params: {
                product_id: product_id,
                locale: window.AG.locale
              }
            })
            .then(response => {
              this.validate();
              this.hasError = false;
              window.showToast(
                  response.data.message,
                  "success",
                  null,
                  ".iziToast-wrapper-buy"
              );
            })
            .catch(error => {
              this.validate();
              this.hasError = true;
              if (error.response.status !== 401) {
                window.showToast(
                    error.message,
                    "error",
                    null,
                    ".iziToast-wrapper-buy"
                );
              } else {
                //this.loginModal = true;
                window.showToast(
                    window.AG.locale == 'ro' ? 'Va rugam sa va autentificati' : 'Please login',
                    "error",
                    null,
                    ".iziToast-wrapper-buy"
                );
              }
            });
      } else {
        window.showToast(
            window.AG.locale == 'ro' ? 'Contul dumneavoastra nu este aprobat' : 'Your account has not been approved yet.',
            "error",
            null,
            ".iziToast-wrapper-buy"
        );
      }
    }, 2000),
    openShareModal: function (event) {
      var number = this.details.number;
      var artist = null;
      if ($("#lotArtist").length > 0) {
        artist = ", " + $("#lotArtist").text();
      }
      var title = subject + ", " + this.details.title.length > 130 ? this.details.title.substring(0, 120) : this.details.title;

      var txt = "Recomand A10 by Artmark - Lot ";
      if (window.AG.locale != 'ro') {
        txt = "Check out A10 by Artmark - Lot no. "
      }

      var subject = number + " " + title;
      if (artist) {
        subject = number + " " + artist + ", " + title;
      }
      var link = window.location.href;
      var lastSlashPosition = link.lastIndexOf('/');
      var lotShareLink = link.substring(lastSlashPosition + 1);
      $("#shareModal").on("show.bs.modal", function (e) {
        $("#facebookShare").attr(
            "href",
            "https://www.facebook.com/sharer/sharer.php?u=https://www.artmark.ro/" + window.AG.locale + "/lot/" +
            lotShareLink +
            "&amp;display=popup"
        );
        $("#emailShare").attr(
            "href",
            "mailto: ?subject=" + txt + subject + "&body=" + txt + subject + "%0D%0A" + link
        )
        ;
      });
      event.preventDefault();
    },
    makeConservationString: function () {
      let auctionDomain = window.AG.auction.domain;
      let mailAddress = this.conservationStatusEmails[auctionDomain];
      if (auctionDomain != window.AG.locale) {
        return "mailto:" + mailAddress + "?subject=Request for information on the conservation status of Lot " + this.details.number + " / Auction A" + this.auction.order + "&body=Lot " + this.details.number + ", " + this.details.title + " - " + this.currentPage;
      } else if (auctionDomain == 'ro') {
        return "mailto:" + mailAddress + "?subject=Cerere informații despre starea de conservare Lot " + this.details.number + " / Licitația L" + this.auction.order + "&body=Lot " + this.details.number + ", " + this.details.title + " - " + this.currentPage;
      } else if (auctionDomain == 'bg') {
        return "mailto:" + mailAddress + "?subject=Заявка за информация относно консервационния статус Лот " + this.details.number + " / Търг Т" + this.auction.order + "&body=Лот " + this.details.number + ", " + this.details.title + " - " + this.currentPage;
      } else if (auctionDomain == 'hr') {
        return "mailto:" + mailAddress + "?subject=Zahtjev za informacijama o konzervatorskom statusu Lota " + this.details.number + " / Aukcija A" + this.auction.order + "&body=Lota " + this.details.number + ", " + this.details.title + " - " + this.currentPage;
      }
    },
    makeAuctionShortName: function () {
      let maxLength = 120;
      if (this.$screen.width <= 768) {
        maxLength = 60;
      }
      if (this.auction.name && this.auction.name.length >= maxLength) {
        var localizedAuction = "Licitația";
        if (window.AG.locale != "ro") {
          localizedAuction = "Auction";
        }
        return (
            localizedAuction +
            " " +
            "#" +
            this.auction.order +
            "/" +
            this.$dayjs(this.auction.start_date).format('YYYY')
        );
      } else {
        return this.auction.name;
      }
    },
    makeLotTitle: function (heritage, archive_preemption, is_price_cumulative) {
      let arrArguments = Array.from(arguments);
      let newArguments = [];
      arrArguments.map(function (value, key) {
        if (value != null || value != 0) {
          if (key == 1 && value == 1) {
            newArguments.push('A');
          } else if (key == 0 && value == 1) {
            newArguments.push('C');
          } else {
            if (value) {
              newArguments.push(value);
            }
          }
        }
      });

      if (newArguments.length > 0) {
        return this.details.number + '<sup>' + newArguments.join(", ") + '</sup>. ' + this.details.title;
      } else {
        return this.details.number + '. ' + this.details.title;
      }
    },
    toggleMore: function () {
      this.more = !this.more;
    },
    erpSync: function () {
      let bodyFormData = new FormData();
      bodyFormData.set("external_id", this.auction.external_id);
      bodyFormData.set("auction_domain", this.auction.domain);
      bodyFormData.set("lot_number", this.details.number);
      bodyFormData.set("sync_action", "sync-lot");
      this.syncing = true;

      let that = this;
      axios({
        method: "post",
        url: "/api/erp-sync",
        data: bodyFormData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
          .then(response => {
            (that.syncing = false),
                (that.confirm_sync = false),
                window.showToast(response.data.message, "success", "bottomRight");
          })
          .catch(error => {
            (that.syncing = false),
                (that.confirm_sync = false),
                window.showToast(
                    error.response.data.message,
                    "error",
                    "bottomRight"
                );
          });
    },
    trim: function (value) {
      value = value.replace(/(^\s*)|(\s*$)/gi, "");
      value = value.replace(/[ ]{2,}/gi, " ");
      value = value.replace(/\n /, "\n");
      try {
        value = value.trimStart();
        value = value.trimEnd();
      } catch (err) { //supress errors for trim

      }

      return value;
    },
    locale: function () {
      return window.AG.locale;
    },
    loadFullImages: function () {
      if (!this.loadedFullImages) {
        this.loadedFullImages = true;
        this.$refs["main-href"].href = this.img_full;
        if (this.img_more_full) {
          for (var i = 0; i < this.img_more_full.length; i++) {
            this.$refs["additional-href-" + i][0].href = this.img_more_full[i];
          }
        }

      }
    },
    youtubeVideoId: function (url) {
      if (!url) {
        return null;
      }

      try {
        var parsed = new URL(url);
        var host = parsed.hostname.toLowerCase();

        if (host === 'youtu.be') {
          return parsed.pathname.split('/').filter(Boolean)[0] || null;
        }

        if (host === 'youtube.com' || host === 'www.youtube.com' || host === 'm.youtube.com') {
          var queryId = parsed.searchParams.get('v');

          if (queryId) {
            return queryId;
          }

          var match = parsed.pathname.match(/^\/(?:embed|shorts|live)\/([^/]+)/);

          return match ? match[1] : null;
        }
      } catch (error) {
        return null;
      }

      return null;
    },
    youtubeIdFromThumbnail: function (url) {
      var match = String(url).match(/(?:img\.youtube\.com|i\.ytimg\.com)\/vi\/([^/]+)/);

      return match ? match[1] : null;
    },
    getDataType: function (item) {
      if (this.youtubeIdFromThumbnail(item)) {
        return 'video';
      } else if (item.includes('artmark')) {
        return 'video';
      }
      return 'image';

    },
    getVideo: function (item) {
      var youtubeVideoId = this.youtubeIdFromThumbnail(item);

      if (youtubeVideoId) {
        return '<div class="wrapper"><div class="video-background"><iframe style="width: 100vw !important" src="https://www.youtube.com/embed/' + youtubeVideoId + '" frameborder="0" allowfullscreen></iframe></div></div>';
      } else if (item.includes('artmark')) {
        item = item.substr(0, item.lastIndexOf(".")) + ".mp4";
        return '<div class="wrapper"><div class="video-background"><iframe style="width: 100vw !important" src="' + item + '" frameborder="0" allowfullscreen></iframe></div></div>';
      }
      return '';

    },
    trimZero: function (number) {
      if (number < 10) {
        number %= 10;
      }
      return number;
    },
    validate: function () {
      let that = this;
      setTimeout(function () {
        that.validated = true;
      }, 1000);
    },
    __: function (key) {
      return window.AG.trans[key];
    },
    __LIVE: function (key) {
      return window.AG.generic[key];
    },
    route: function (key) {
      return window.AG.routes[key];
    },
    nextLot: function () {
      this.$router.push({name: "lot", params: next});
    },
    prevLot: function () {
      this.$router.push({name: "lot", params: prev});
    },
    goToLot: function (ev) {
      switch (ev.keyCode) {
        case 13:
          if (this.lotJump) {
            var lot = this.lots.find(lot => lot.number == this.lotJump);
            if (lot != undefined) {
              this.$router.push({
                name: "lot",
                params: {
                  auction: this.auction.slug,
                  lot: lot.slug
                }
              });
            }
          }
          break;
        case 27:
          this.lotJump = "";
          break;
      }
    },

    goToLotInput: function (ev) {
      var lot = this.lots.find(lot => lot.number == ev.target.value);
      if (lot != undefined) {
        this.$router.push({
          name: "lot",
          params: {
            auction: this.auction.slug,
            lot: lot.slug
          }
        });
      } else {
        window.showToast(
            this.__("lot-jump-error"),
            "warning",
            null,
            ".iziToast-top-container-placeholder"
        );
      }
    },

    loginUser: function () {
      let user = this.$refs.username_login.value;
      let pass = this.$refs.password_login.value;
      if (!user || !pass) {
        return;
      }

      this.loadingLogin = true;
      let url = window.AG.locale == 'ro' ? '/ro/autentificare' : '/en/login';

      var bodyFormData = new FormData();
      bodyFormData.set("email", this.$refs.username_login.value);
      bodyFormData.set("password", this.$refs.password_login.value);
      bodyFormData.set("product_id", this.details.id);
      bodyFormData.set("value", this.offerValue);
      bodyFormData.set("locale", window.AG.locale);

      let that = this;
      axios({
        method: "post",
        url: url,
        data: {
          'email': this.$refs.username_login.value,
          'password': this.$refs.password_login.value,
          'offers': '[' + localStorage.getItem('localSavedOffers') + ']'
        },

      }).then(function (response) { //succes pe login

        that.loadingLogin = false;
        localStorage.removeItem('localSavedOffers');
        $("#offersModalBtn").hide();
        if (count(request.data) > 0) {
          response.data.forEach(function (offerResult) {
            if (offerResult.original.status && offerResult.original.status == 'ok') {
              window.showToast(
                  offerResult.original.message,
                  "success",
                  null,
                  ".iziToast-wrapper-modal"
              );
            } else {
              window.showToast(
                  offerResult.original.message,
                  "error",
                  null,
                  ".iziToast-wrapper-modal"
              );
            }
          });
        }

        setTimeout(function () {
          that.loginModal = false;
          location.reload();
        }).catch(function (error) {
          if (error.response.status === 401) {
            that.loadingLogin = false;
            window.showToast(
                error.response.data.message,
                "error",
                null,
                ".iziToast-wrapper-modal"
            );
          } else {
            that.loadingLogin = false;
            that.loginModal = false;
            //window.showToast(error.response.data.message,"error","bottomCenter");
            location.reload();
          }


        });
      });
    },
    gtag_report_conversion(url) {
      var callback = function () {
        if (typeof url != "undefined") {
        }
      };
      gtag("event", "conversion", {
        send_to: "AW-955278373/WL7ACM-yyacBEKXIwccD",
        event_callback: callback
      });
      return false;
    },
    addToFavorites: function (event) {
      document.activeElement.blur();
      if (this.loggedIn) {
        event.stopPropagation();
        this.type = 'lot';

        axios({
          method: "post",
          url: "/api/add-favorites",
          data: {"favorites": [{"type": this.type, "id": this.details.id}]},
          config: {
            headers: {
              "Content-Type": "application/json"
            }
          }
        }).then((response) => {
          this.isFavorite = true;
        }).catch(function (error) {
          if (error.response.status === 401) {
            window.showToast(
                error.response.data.message,
                "error",
                null,
                ".iziToast-wrapper-modal"
            );
          } else {
            location.reload();
          }
        });
      } else {
        let localFavorites = localStorage.getItem('localFavorites');

        localFavorites = localFavorites ? localFavorites.split(',') : [];
        localFavorites.push(JSON.stringify({
          type: 'lot',
          fav_id: this.details.id,
          whereFrom: location.href
        }));

        localStorage.setItem('localFavorites', localFavorites);
        window.location.replace('/login')
      }
      event.preventDefault();
    },
    removeFromFavorites: function (event) {
      document.activeElement.blur();
      event.stopPropagation();
      this.type = 'lot';
      axios({
        method: "post",
        url: "/api/remove-favorites",
        data: {"favorites": [{"type": this.type, "id": this.details.id}]},
        config: {
          headers: {
            "Content-Type": "application/json"
          }
        }
      }).then((response) => {
        var msg = window.AG.locale == 'ro' ? 'Nu mai urmarești acest artist.' : 'Artist unfollowed';
        window.showToast(
            msg,
            "success",
            null,
            ".iziToast-wrapper-artist"
        );
        this.isFavorite = false;
      }).catch(function (error) {
        if (error.response.status === 401) {
          window.showToast(
              error.response.data.message,
              "error",
              null,
              ".iziToast-wrapper-modal"
          );
        } else {
          location.reload();
        }
      });
      event.preventDefault();
    },
    followArtist: function (event) {

      if (this.loggedIn) {
        event.stopPropagation();
        this.type = 'artist';

        if (this.isFollowed) {
          var msgErr = window.AG.locale == 'ro' ? 'Artist deja adăugat!' : 'Artist was already added!';
          window.showToast(
              msgErr,
              "error",
              null,
              ".iziToast-wrapper-artist"
          );
        } else {
          axios({
            method: "post",
            url: "/api/add-favorites",
            data: {"favorites": [{"type": this.type, "id": this.details.artists[0].id}]},
            config: {
              headers: {
                "Content-Type": "application/json",
              }
            }
          }).then((response) => {
            this.isFollowed = true;
            var msg = window.AG.locale == 'ro' ? 'Artist adăugat. Vezi artiștii urmăriți în secțiunea Favorite din contul tău.' : 'Followed artist! See all artists followed in the Favorites tab from your account.';
            window.showToast(
                msg,
                "success",
                null,
                ".iziToast-wrapper-artist"
            );
          }).catch(function (error) {
            if (error.response.status === 401) {
              window.showToast(
                  error.response.data.message,
                  "error",
                  null,
                  ".iziToast-wrapper-artist"
              );
            }
          });
        }
      } else {
        let localFavorites = localStorage.getItem('localFavorites');

        localFavorites = localFavorites ? localFavorites.split(',') : [];
        localFavorites.push(JSON.stringify({
          type: 'artist',
          fav_id: this.details.artists[0].id,
          whereFrom: location.href
        }));

        localStorage.setItem('localFavorites', localFavorites);
        window.location.replace('/login')
      }
      event.preventDefault();
    },
    unfollowArtist: function (event) {
      document.activeElement.blur();
      event.stopPropagation();
      this.type = 'artist';
      axios({
        method: "post",
        url: "/api/remove-favorites",
        data: {"favorites": [{"type": this.type, "id": this.details.artists[0].id}]},
        config: {
          headers: {
            "Content-Type": "application/json"
          }
        }
      }).then((response) => {
        this.isFollowed = false;
        var msg = window.AG.locale == 'ro' ? 'Artist eliminat!' : 'Artist removed!';
        window.showToast(
            msg,
            "success",
            null,
            ".iziToast-wrapper-artist"
        );
      }).catch(function (error) {
        if (error.response.status === 401) {
          window.showToast(
              error.response.data.message,
              "error",
              null,
              ".iziToast-wrapper-modal"
          );
        } else {
          location.reload();
        }
      });
      event.preventDefault();
    },
    setCookie: function (name, value) {
      var cookieDate = new Date();
      cookieDate.setFullYear(cookieDate.getFullYear() + 10);

      var cookie = name + "=" + JSON.stringify(value) + "; expires=" + cookieDate.toUTCString();
      document.cookie = cookie;
    },
    getCookie: function (name) {
      var cookieArr = document.cookie.split(";");
      var found = null;

      for (var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");
        if ('tours' == cookiePair[0].trim()) {
          JSON.parse(cookiePair[1], (key, value) => {
                if (key === name) {
                  found = value;
                }
              }
          );
        }
      }
      return found;
    },
    placeOffer: throttle(function () {
      if (this.approval_status !== 5) {
        this.validated = false;
        var product_id = this.details.id;
        axios
            .get("/api/offer", {
              params: {
                product_id: product_id,
                value: this.offerValue,
                locale: window.AG.locale,
                logged_in: this.loggedIn
              }
            })
            .then(response => {
              this.validate();
              this.hasError = false;
              this.offerValue = "";
              window.showToast(
                  response.data.message,
                  "success",
                  null,
                  ".iziToast-wrapper-offer"
              );
            })
            .catch(error => {
              this.validate();
              this.hasError = true;
              if (error.response.status !== 401) {
                window.showToast(
                    error.response.data.message,
                    "error",
                    null,
                    ".iziToast-wrapper-offer"
                );
              } else {
                // Get the existing local offers
                let localSavedOffers = localStorage.getItem('localSavedOffers');

// // If no offers, create an array
// // If offers, convert the localSavedOffers string to an array
                localSavedOffers = localSavedOffers ? localSavedOffers.split(',') : [];
//i hate js
                var date = new Date(); // Or the date you'd like converted.


// // Add new data to localSavedOffers
                localSavedOffers.push(JSON.stringify({
                  product_id: product_id,
                  value: this.offerValue,
                  locale: window.AG.locale,
                  created_at: new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString()
                }));
//
// // Save back to localStorage
                localStorage.setItem('localSavedOffers', localSavedOffers);

                var localSavedOffersInit = JSON.parse('[' + localStorage.getItem('localSavedOffers') + ']');
                var previousLocalOffer = [];
                if (localSavedOffersInit.length > 1) {
                  for (var i = 0; i < localSavedOffersInit.length; i++) {
                    if (localSavedOffersInit[i]['product_id'] === product_id) {
                      previousLocalOffer.push(i);
                      if (previousLocalOffer.length > 1) {
                        localSavedOffersInit.splice(Math.min(...previousLocalOffer), 1);
                      }
                    }
                  }
                  localStorage.removeItem('localSavedOffers');
                  localSavedOffersInit = JSON.stringify(localSavedOffersInit);
                  localStorage.setItem('localSavedOffers', localSavedOffersInit.substring(1, localSavedOffersInit.length - 1));
                }
                $("#offersModalBtn").show();
                $("#offersModalBtn").click();
                //this.loginModal = true;
              }
            });
      }
    }, 2000),
    placeOfferPostAuction: throttle(function () {
      if (!this.loggedIn) {
        window.showToast(
            window.AG.locale == 'ro' ? 'Va rugam sa va autentificati' : 'Please login',
            "error",
            null,
            ".iziToast-wrapper-offer"
        );
        // this.loginModal = true;
        return false;
      }
      if (this.approval_status !== 5) {
        this.validated = false;
        var product_id = this.details.id;
        var post_auction_price = this.details.post_auction_price;
        axios
            .get("/api/buy-now", {
              params: {
                product_id: product_id,
                value: post_auction_price,
                locale: window.AG.locale
              }
            })
            .then(response => {
              this.validate();
              this.hasError = false;
              this.offerValue = "";
              window.showToast(
                  response.data.message,
                  "success",
                  null,
                  ".iziToast-wrapper-offer"
              );
            })
            .catch(error => {
              this.validate();
              this.hasError = true;
              if (error.status !== 401) {
                window.showToast(
                    error.message,
                    "error",
                    null,
                    ".iziToast-wrapper-offer"
                );
              } else {
                this.loginModal = true;
              }
            });
      }
    }, 2000)
  },
  mounted() {
    this.loading = true;
    this.$store.dispatch("loadLot", {slug: this.lot}).then(data => {
      this.details = data;
      this.auction = window.AG.auction;
      this.loading = false;
      if (this.loggedIn) {
        this.checkFavorites();
        this.userHasBids()
      }
      this.getHighestBidder();

      if (window.AG.auction.mode == 4 || window.AG.auction.mode == 5) {
        this.getBiddingSteps();
      }
    });
    //log lot visit
    axios
        .get("/api/lot-visit", {
          params: {
            slug: this.lot
          }
        }).then().catch();
    this.setupPusher();

  },
  updated() {
    if (this.updatedCount > 0) {
      if (!this.pswp_init) {
        initPhotoSwipeFromDOM(".lot-image-container figure");
        this.pswp_init = true;
        if (this.goToOffer == 1) {
          this.$refs.placeOffer.focus();
        }
      }
      if (window.AG.flashMessage) {
        window.showToast(
            window.AG.flashMessage,
            window.AG.flashType,
            null,
            ".iziToast-wrapper-offer"
        );
        window.AG.flashMessage = null;
      }
      if (window.AG.focusOffer) {
        this.$refs.placeOffer.focus();
        window.AG.focusOffer = null;
      }
    }

    this.updatedCount++;
    if (this.img_more && this.img_more.length > 3) {
      var swiper_additional_images = new Swiper(".swiper-additional-images", {
        centeredSlide: true,
        loop: false,
        slidesPerView: 4,
        spaceBetween: 30,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        // If we need pagination
        pagination: {
          el: ".swiper-pagination-additional-images",
          paginationClickable: true,
          type: "bullets",
          bulletElement: "span",
          clickable: true
        },

        // Navigation arrows
        navigation: {
          nextEl: ".next-additional-images",
          prevEl: ".prev-additional-images"
        }
      });
    }
    // $('[data-toggle="modal"]').tooltip()
  },
  computed: {

    console: () => console,
    canEditLots: function () {
      return window.AG.caneditlots;
    },
    canEditAuctions: function () {
      return window.AG.caneditauctions;
    },
    artmarkLive: function () {
      return window.AG.artmark_live;
    },
    amLiveLink: function () {
      return window.AG.am_live;
    },
    amLiveTimedLink: function () {
      return window.AG.am_live_timed;
    },
    approval_status: function () {
      return window.AG.approval_status;
    },
    loggedIn: function () {
      return window.AG.loggedIn;
    },
    loggedInId: function () {
      return window.AG.loggedInId;
    },
    currentPage: function () {
      return window.location.href;
    },
    settings: function () {
      return window.AG.settings.live_auction;
    },
    img: function () {
      return this.details.details_image_url;
    },
    img_full: function () {
      return this.details.main_image_url;
    },
    youtubeVideos: function () {
      var that = this;

      if (!this.details.video) {
        return [];
      }

      return this.details.video
          .split(',')
          .map(function (url) {
            url = url.trim();

            if (!url) {
              return null;
            }

            var videoId = that.youtubeVideoId(url);

            if (!videoId) {
              return null;
            }

            return {
              url: url,
              id: videoId,
              thumbnail: 'https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg',
              embed: 'https://www.youtube.com/embed/' + videoId
            };
          })
          .filter(Boolean);
    },
    youtubeThumbnails: function () {
      return this.youtubeVideos.map(function (video) {
        return video.thumbnail;
      });
    },
    img_more: function () {
      return (this.details.additional_image_thumbnails_url || []).concat(this.youtubeThumbnails);
    },
    img_more_full: function () {
      return (this.details.additional_images_url || []).concat(this.youtubeThumbnails);
    },
    img_more_labels: function () {
      return (this.details.additional_images_labels || []).concat(
          this.youtubeVideos.map(function () {
            return 'Video';
          })
      );
    },
    next: function () {
      var lots = this.$store.getters.lots;
      var position = lots.findIndex(lot => lot.id === this.details.id);
      if (lots[position + 1] == undefined) return false;
      var next_slug = lots[position + 1].slug;
      return {
        auction: this.auction.slug,
        lot: next_slug
      };
    },
    prev: function () {
      var lots = this.$store.getters.lots;
      var position = lots.findIndex(lot => lot.id === this.details.id);
      if (lots[position - 1] == undefined) return false;
      var prev_slug = lots[position - 1].slug;
      return {
        auction: this.auction.slug,
        lot: prev_slug
      };
    },
    howToSellUrl: function () {
      return window.AG.how_to_sell_url + "#form-contact-howToSell";
    },
    auction: {
      get() {
        return this.currentAuction ? this.currentAuction : window.AG.auction;
      },
      set(object) {
        this.currentAuction = object;
      }
    },
    lots: function () {
      return this.$store.getters.lots;
    },
    dif: function () {
      if (!this.auction || !this.auction.display_start_timestamp) {
        return 0;
      }

      var auctionStartTimestamp = Number(this.auction.display_start_timestamp);
      var dif = auctionStartTimestamp - Date.now();

      return dif > 0 ? dif : 0;
    },
    hoursToAuction: function () {
      if (!this.auction || !this.auction.display_start_timestamp) {
        return 0;
      }

      var auctionStartTimestamp = Number(this.auction.display_start_timestamp);
      var hoursToAuction = auctionStartTimestamp - Date.now();

      return hoursToAuction / 3600000;
    },
    description: function () {
      let n = 700;
      if (this.details.description.length <= n || this.more) {
        return {
          content: this.details.description,
          more: false
        };
      }
      var subString = this.details.description.substr(0, n - 1);
      return {
        content: subString.substr(0, subString.lastIndexOf(" ")) + "&hellip;",
        more: true
      };
    },
    medium: function () {
      let n = 700;
      if (this.details.medium.length <= n || this.more) {
        return {
          content: this.details.medium,
          more: false
        };
      }
      var subString = this.details.medium.substr(0, n - 1);
      return {
        content: subString.substr(0, subString.lastIndexOf(" ")) + "&hellip;",
        more: true
      };
    },
  },
  created() {

  }
};
</script>